import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

import { selectCurrentUser } from 'store/user/selectors';

import { CONTACT_US_LINK } from 'constants/links';
import { DEFAULT_LANGUAGE, LANG_TO_LOCALE_MAP } from 'constants/localization';
import { WEB_PAYMENT_PLATFORM, WEB_USER_SOURCE } from 'constants/user';

import { getDeviceInfo } from 'helpers/utils';

import { URL_PARAMS } from './constants';

export const useGetCFLink = () => {
    const { os, browser } = getDeviceInfo();
    const { name, email, user_id, language, country, ab_test_name, gender } = useSelector(selectCurrentUser);
    const payment_platform = user_id ? WEB_PAYMENT_PLATFORM : '';

    const locale = LANG_TO_LOCALE_MAP[language ?? DEFAULT_LANGUAGE];

    const [uuid, setUuid] = useState(() => localStorage.getItem(URL_PARAMS.ANALYTIC_UUID) ?? '');

    useEffect(() => {
        if (uuid) return;

        const timeout = setTimeout(() => {
            const storedUuid = localStorage.getItem(URL_PARAMS.ANALYTIC_UUID);

            if (storedUuid) {
                setUuid(storedUuid);
            }
        }, 100);

        return () => clearTimeout(timeout);
    }, [uuid]);

    return useMemo(() => {
        const queryParams = new URLSearchParams({
            locale,
            name: name ?? '',
            user_id: user_id ?? '',
            email: email ?? '',
            os_version: os,
            model: browser,
            payment_platform,
            source: WEB_USER_SOURCE,
            gender: gender ?? '',
            country: country ?? '',
            uuid: uuid ?? '',
            ab_test_name: ab_test_name ?? '',
        });

        return `${CONTACT_US_LINK}?${queryParams.toString()}`;
    }, [uuid, name, email, user_id, locale, payment_platform, os, browser, gender, country, ab_test_name]);
};
